module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_04_1280_1280_ko-6db1ba5983c3876553c257a74b0b0a3e.jpg";